import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { settingsService } from '../services/settingsService';
import type { FiscalYear } from '../types';

interface FiscalYearContextType {
  fiscalYears: FiscalYear[];
  loading: boolean;
  refetch: () => Promise<void>;
}

const FiscalYearContext = createContext<FiscalYearContextType | undefined>(undefined);

export function FiscalYearProvider({ children }: { children: ReactNode }) {
  const [fiscalYears, setFiscalYears] = useState<FiscalYear[]>([]);
  const [loading, setLoading] = useState(true);

  const refetch = async () => {
    try {
      const data = await settingsService.getFiscalYears();
      setFiscalYears(data);
    } catch (error) {
      console.error('Failed to fetch fiscal years:', error);
    }
  };

  useEffect(() => {
    refetch().finally(() => setLoading(false));
  }, []);

  return (
    <FiscalYearContext.Provider value={{ fiscalYears, loading, refetch }}>
      {children}
    </FiscalYearContext.Provider>
  );
}

export function useFiscalYears() {
  const context = useContext(FiscalYearContext);
  if (!context) {
    throw new Error('useFiscalYears must be used within a FiscalYearProvider');
  }
  return context;
}